/* eslint-disable max-len */

export const useDeepLink = () => {
    const {
        navigator: { userAgent },
        location,
        // eslint-disable-next-line no-undef
    } = window

    const isIOS = userAgent.match(/iPhone|iPad|iPod/i) !== null
    const isAndroid = userAgent.match(/Android/i) !== null

    const params = new URLSearchParams(location.search)
    const tokenToRecoverPassword = params.get('token')
    const paramsInJson = `{"token":"${tokenToRecoverPassword}"}`

    const deepLinkToUpdatePasswordIOS = `nav://?stack=LoginStack&screen=CreatePassword&params=${paramsInJson}`
    const deepLinkToWaitingRoomIOS = 'nav://?stack=COAStack&screen=WaitingRoom'

    const deepLinkToUpdatePasswordAndroid = `intent://MainStack/?stack=LoginStack&screen=CreatePassword&params=${paramsInJson}#Intent;scheme=nav;package=br.com.nav;end`
    const deepLinkToWaitingRoomAndroid =
        'intent://MainStack/?stack=COAStack&screen=WaitingRoom#Intent;scheme=nav;package=br.com.nav;end'

    const deepLinkToOpenIOS = tokenToRecoverPassword ? deepLinkToUpdatePasswordIOS : deepLinkToWaitingRoomIOS
    const deepLinkToOpenAndroid = tokenToRecoverPassword ? deepLinkToUpdatePasswordAndroid : deepLinkToWaitingRoomAndroid

    return {
        deepLinkToOpenAndroid,
        deepLinkToOpenIOS,
        isAndroid,
        isIOS,
        location,
    }
}
